import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import { GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGINS_KEY } from '@/keys';
import type { ProductionDeclarationCommodityOrigin } from '@/types/core/purchase-order/production-declaration-commodity-origin';

type CreateProductionDeclarationMaterialCommodityOriginVariables = {
  productionDeclarationId: string;
  materialId: string;
  token?: string;
};

async function createProductionDeclarationMaterialCommodityOrigin({
  productionDeclarationId,
  materialId,
  token,
}: CreateProductionDeclarationMaterialCommodityOriginVariables): Promise<ProductionDeclarationCommodityOrigin> {
  const response = await api.post<ProductionDeclarationCommodityOrigin>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins`,
    undefined,
    {
      params: token ? { token } : undefined,
    },
  );

  return response.data;
}

export function useCreateProductionDeclarationMaterialCommodityOrigin(): UseMutationResult<
  ProductionDeclarationCommodityOrigin,
  Error,
  CreateProductionDeclarationMaterialCommodityOriginVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createProductionDeclarationMaterialCommodityOrigin,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          ...GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGINS_KEY,
          variables.productionDeclarationId,
          variables.materialId,
          variables.token ?? '',
        ],
      });
    },
  });
}
